import { PortableTextBlock } from "@portabletext/react";
import mediaQuery from "@utils/mediaQuery";
import styled from "styled-components";
import RichText from "./RichText";

const Container = styled.div`
  display: flex;
  flex: 1;
  padding: 24px;
  flex-direction: column;
  align-self: flex-start;
  box-sizing: border-box;

  border-radius: 12px;
  background: rgba(255, 255, 255, 0.4);

  p {
    font-size: var(--font-size-base);
    font-weight: var(--font-weight-normal);
    line-height: 20px;
    letter-spacing: var(--letter-spacing-wide);
  }

  ${mediaQuery("tablet")`
    width: 100%;

    p {
        font-size: var(--font-size-xl);
        line-height: 25.6px;
      }
  `}
`;

const RecommendationCopy = ({ copy }: { copy: PortableTextBlock[] }) => {
  return (
    <Container>
      <RichText copy={copy} />
    </Container>
  );
};

export default RecommendationCopy;
